module.exports = __webpack_public_path__ + "static/bz-0e7f759669ad3e604a901195f76ef730.svg";